
import Vue, { PropType } from 'vue'
import Opz2Icon from './Opz2Icon.vue'
import Opz2Cards from './Opz2Cards.vue'
import Opz2DetailTable from './Opz2DetailTable.vue'
import { CrossFlag, Report, Row, cnt, fnPct } from './model'

const TIMES: Array<{ id: CrossFlag; label: string; help: string }> = [
    { id: 'all', label: 'Все', help: 'Показываем все записи: на тот же день и на последующие даты.' },
    { id: 'same_day', label: 'День в день', help: 'Дата визита совпадает с датой создания записи.' },
    { id: 'future_day', label: 'На будущее', help: 'Дата визита позже даты создания записи.' },
    {
        id: 'firstly',
        label: 'Впервые',
        help: 'Клиента записали на категорию услуг, на которой он ещё не был.',
    },
]

/** Фильтр — параметр flag_cross_sail функции; карточки и строки — cross_sail_total / cross_sail_table как есть. */
export default Vue.extend({
    name: 'Opz2CrossPane',
    components: { Opz2Icon, Opz2Cards, Opz2DetailTable },
    props: {
        report: { type: Object as PropType<Report>, required: true },
    },
    data: () => ({ times: TIMES }),
    computed: {
        current(): typeof TIMES[number] {
            return TIMES.find(item => item.id === this.report.cross.flag) ?? TIMES[0]
        },
        rows(): Row[] {
            return this.report.cross.rows
        },
        cards(): any[] {
            const t: Row = this.report.cross.total
            return [
                {
                    label: 'Записей после фильтрации',
                    value: cnt(t.cross_sails_cnt),
                    note: `${cnt(t.cross_sails_active_cnt)} записей без отмен`,
                    color: 'indigo',
                },
                {
                    label: 'Завершено визитов',
                    value: cnt(t.cross_sails_success_cnt),
                    note: 'Клиенты уже пришли',
                    color: 'teal',
                },
                {
                    label: 'Впервые',
                    value: cnt(t.cross_sails_firstly_cnt),
                    note: 'Клиента записали на категорию услуг, на которой он ещё не был',
                    color: 'wasabi',
                },
                {
                    label: 'Отменено',
                    value: cnt(t.cross_sails_cancel_cnt),
                    note: `${fnPct(t.cross_sails_cancel_percent)} от выбранных записей`,
                    color: 'red',
                },
            ]
        },
    },
})
